<template>
    <v-row>
        <v-col cols="12" v-for="(error,index) in errors.non_field_errors" :key="index">
        <v-alert type="error">
            {{error}}
        </v-alert>
    </v-col>
    </v-row>
</template>

<script>
    export default {
        name: "NonFormFieldErrors",
        props:{
            errors:{
                type:Object,
                required:true
            }
        }
    }
</script>

<style scoped>

</style>